import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BookmarkService, BookmarkVisibilityItem, BookmarkVisibilityValue, MapBookmark } from 'app/services/bookmark.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';

export interface ReferenceDocumentInputData {
	bookmarkList: MapBookmark[];
}
@Component({
  selector: 'app-feat-reference-document',
  templateUrl: './feat-reference-document.component.html',
  styleUrls: ['./feat-reference-document.component.css', '../feat-map-bookmark-manager/feat-map-bookmark-manager.component.css']
})
export class FeatReferenceDocumentComponent implements OnInit {


	bookmarkName: string;
	bookmarkVisibilities: BookmarkVisibilityItem[];
	bookmarkVisib: BookmarkVisibilityValue;
	bookmarkDesc: string;
	bookmarkHref: string;

	bookmarkList: MapBookmark[] = [];
	columns: {
		prop: string;
		name: string;
	}[];
	userName: string;

	isAdding: boolean;
	deletingId: number;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ReferenceDocumentInputData,
		public dialogRef: MatDialogRef<FeatReferenceDocumentComponent>,
		private toastr: ToastrService,
		private bookmarkService: BookmarkService,
		private userService: UserService
	) { }

	cancel() {
		this.dialogRef.close();
	}

	async getBookmarks() {
		const bookmarks = await this.bookmarkService.getMapBookmarks('HREF');
		this.bookmarkList = bookmarks;
	}
	async addBookmark() {
		this.isAdding = true;
		try {
			await this.bookmarkService.addMapBookmarks(this.bookmarkName, this.bookmarkDesc, this.bookmarkVisib, 'HREF', null, this.bookmarkHref);
			this.toastr.success('Successfully added');
			this.bookmarkName = null;
			this.bookmarkDesc = null;
			this.bookmarkHref = null;
			await this.getBookmarks();
		} catch (err) {
			console.log(err)
		}
		this.isAdding = false;
	}
	async deleteBookmark(bookmark: MapBookmark) {
		this.deletingId = bookmark.id;
		try {
			await this.bookmarkService.deleteMapBookmark(bookmark.id);
			this.toastr.success('Successfully deleted');
			await this.getBookmarks();
		} catch (err) {
			console.log(err)
		}
		this.deletingId = null;
	}
	ngOnInit() {
		this.columns = [
			{
				prop: 'name',
				name: 'NAME'
			},
			// {
			// 	prop: 'desc',
			// 	name: 'Description'
			// },
			{
				prop: 'ownerDisplay',
				name: 'OWNER'
			},
			{
				prop: 'visibility',
				name: 'VISIBILITY'
			},
			{
				prop: 'delete',
				name: ' '
			}
		];
		this.bookmarkVisibilities = this.bookmarkService.bookmarkVisibilities;
		this.bookmarkVisib = this.bookmarkVisibilities[0].value;
		this.userName = this.userService.getUserInfo().userEmail;
		// await this.getBookmarks();
		this.bookmarkList = this.data.bookmarkList;
	}

}
